module.exports = __webpack_public_path__ + "assets/img/car.687a046f.svg";